"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Hyper = function Hyper(_ref) {
  var borderColor = _ref.borderColor,
      offsetColor = _ref.offsetColor;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 208 209"
  }, _react.default.createElement("path", {
    fill: "#63DC3E",
    d: "M189.22 149.7l-49.8 51.32H69L19.19 149.7v-10.4h-7.44v13.59l54.16 55.81h76.6l54.16-55.81v-13.6h-7.45v10.42zM142.5.88H65.91L22.37 45.73 11.75 56.7v3.35h7.44v-.17l13.7-14.13L69 8.54h70.42l36.1 37.2 13.71 14.13v.17h7.45V56.7l-10.63-10.95L142.5.87z"
  }), _react.default.createElement("path", {
    fill: "#63DC3E",
    d: "M.15 51.77v79.92h97.09V51.77H.15zm89.3 71.3H7.94V60.4h81.5v62.67zm21.43-71.3v79.92h97.1V51.77h-97.1zm89.3 71.3h-81.5V60.4h81.5v62.67z"
  }), _react.default.createElement("path", {
    fill: "#63DC3E",
    d: "M114.89 68.73H92.97v8.69h21.92v-8.69zM79.35 53.1l-40.47 72.55L46.2 130l40.47-72.55-7.33-4.34zm110.2.42l-40.47 72.22 7.3 4.35 40.47-72.23-7.3-4.34zM37.96 144.66v7.3l37.98 39.13v.03h56.65v-.02l37.98-39.15v-7.3H37.97zm91.67 39.16H78.91l-30.93-31.87h112.58l-30.93 31.87z"
  }));
};

Hyper.propTypes = {
  borderColor: _propTypes.default.string,
  offsetColor: _propTypes.default.string
};
Hyper.defaultProps = {
  borderColor: "#242523",
  offsetColor: "#63DC3E"
};
var _default = Hyper;
exports.default = _default;